import { useContext } from 'react';
import AppContext from '../context/App';

export default function useDeviceInfo() {
    const { deviceInfo } = useContext(AppContext) || {};
    return deviceInfo;
}
